import useGetUserMeta from './useGetUserMeta';

export default useGetUserMeta;
